var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-empty"},[_c('div',{staticClass:"image",style:({height:_vm.size})},[_c('img',{attrs:{"src":_vm.image,"alt":""}})]),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }